'use client';

import { createContext } from 'react';
import type { ICommandPaletteContextValue } from './use-command-palette-context-types';

export const CommandPaletteContext = createContext<ICommandPaletteContextValue | null>(null);
